import { formatDate } from "@platform/style";

export enum ActivityType {
  CREATE = "CREATE",
  CLAIM = "CLAIM",
  ACTIVATE = "ACTIVATE",
  HOLD = "HOLD",
  ASSIGN = "ASSIGN",
  CANCEL = "CANCEL",
  COMPLETE = "COMPLETE",
  TERMINATE = "TERMINATE",
  TRANSFER = "TRANSFER",
}

export interface ActivityParameter {
  Key: string;
  Value: string;
}

export interface ActivityRecord {
  ActivityRecordIdentifier: string;
  Activity: ActivityType;
  ActivityParameters: ActivityParameter[];
  Comment: string;
  PerformedBy: string;
  ActivityDatetime: Date;
}

export function getActivityParameterKey(record: ActivityRecord): string {
  if (record.ActivityParameters && record.ActivityParameters.length > 0)
    return record.ActivityParameters[0].Key;
  return "";
}

export function getActivityParameterValue(record: ActivityRecord): string | null {
  const value: string = record.ActivityParameters[0].Value;

  if (getActivityParameterKey(record) === "FollowupDate") {
    return formatDate(new Date(value + "T00:00:00"));
  }
  return value;
}
